import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase.js';
import { Menu, LogOut } from 'lucide-react';
import NotificationBell from '../components/admin/NotificationBell.js';

const AdminHeader = ({ user, userProfile, onToggleMobileMenu, roleLabel = 'Administrador' }) => {
    return (
        <header className="header">
            <button className="hamburger-btn" onClick={onToggleMobileMenu} aria-label="Abrir menú">
                <Menu size={24} />
            </button>
            <div className="welcome-message">
                <span>
                    <span className="welcome-text-prefix">Bienvenido, </span>
                    <strong>{userProfile?.fullName || user?.email}</strong>
                    <span className="role-label" style={{ fontSize: '0.85rem', color: '#6b7280', marginLeft: '0.35rem' }}>· {roleLabel}</span>
                </span>
            </div>
            <div className="header-actions">
                <NotificationBell />
                <button onClick={() => signOut(auth)} className="sign-out-button" title="Cerrar Sesión">
                    <LogOut size={20} className="sign-out-icon" />
                </button>
            </div>
        </header>
    );
};

export default AdminHeader;